import { NodeTreeState } from '@myua/nodetree';
import { MessagesInterface } from '../../../general/model';

import { CHNode, NodeLabel } from '../../../general/node';
import { APIScenarioReturn } from '../../../general/apiSagaFactory';

export type TRichResult = APIScenarioReturn<{ id: number } | 'skipped'> & { node: CHNode };

export enum MoverJobStatus {
  // статусы из апи
  PENDING = 'PENDING',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',

  // внутренние статусы
}

export type APITaskState = MoverJobStatus.FAILURE | MoverJobStatus.PENDING | MoverJobStatus.SUCCESS;

export const settledStatuses = [MoverJobStatus.FAILURE, MoverJobStatus.SUCCESS];
export const failedStatuses = [MoverJobStatus.FAILURE];
export type AsyncMoverJob = {
  groupID: string;
  mode: MoverDialogMode;
  node: NodeLabel; // нода, которую копируем
  target: NodeLabel; // новый родитель
  progress: number;
  state: MoverJobStatus.FAILURE | MoverJobStatus.PENDING | MoverJobStatus.SUCCESS;
  error: string | null;
};

export enum MoverDialogMode {
  MOVE = 'MOVE',
  COPY = 'COPY',
  EXTERNAL = 'EXTERNAL',
}

export const TREE_REDUCER_KEY = 'mover.tree';

export type DialogShape = {
  isOpen: boolean;
  mode: MoverDialogMode | null;
  sourceNodeID: null | number;
  selectedNodeID: null | number;
  defaultNodeID: null | number;
  inProgress: boolean;
};

export const dialogInitialState: DialogShape = {
  isOpen: false,
  mode: null,
  sourceNodeID: null,
  selectedNodeID: null,
  defaultNodeID: null,
  inProgress: false,
};
export type MoverShape = {
  tree: NodeTreeState;
  dialog: DialogShape;
  jobs: AsyncMoverJob[];
};

export const Messages: MessagesInterface = {
  cantGetResultNode: (nodeID) => ({
    title: 'Problem getting job result',
    message: `Error getting info about node ${nodeID}`,
  }),
  success: (results: TRichResult[], mode: MoverDialogMode) => {
    const successItems = results.filter((x) => x.success && x.data.response !== 'skipped').length;
    const skippedItems = results.filter((x) => x.success && x.data.response === 'skipped').length;
    const message =
      mode === MoverDialogMode.MOVE
        ? `${successItems} item moved successfully`
        : `${successItems} item copied successfully`;
    const skippedMessage = skippedItems !== 0 ? ` (${skippedItems} skipped)` : '';

    return {
      title: 'Operation completed successfully',
      message: message + skippedMessage,
    };
  },
  error: (failedNodeNames: any[], mode: MoverDialogMode) => ({
    title:
      mode === MoverDialogMode.MOVE
        ? 'We have a problem moving some items'
        : 'We have a problem copying some items',
    message: failedNodeNames.join(', '),
  }),
};
